<div
  class="sp-shared-info"
  [ngClass]="layout_class">
  <h5 class="sp-color__primary sp-opacity__three-quarters">
    {{ label || '' | translate }}
  </h5>

  <div
    class="sp-row__align"
    (click)="is_content_clickable && content_click.emit()"
    [class.sp-cursor__pointer]="is_content_clickable">
    <p
      *ngIf="content"
      [ngClass]="content_class">
      {{ content || '' | translate }}
    </p>

    <ng-content></ng-content>

    <mat-icon
      (click)="update_click.emit(); $event.stopPropagation()"
      *ngIf="is_update_enabled"
      [matTooltip]="update_tooltip || '' | translate"
      class="sp-color__accent sp-cursor__pointer">
      create
    </mat-icon>
  </div>

  <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark" />
</div>
